var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.item.tags),function(tag,i){return _c('Tag',{key:("" + (tag.value) + i)},[_vm._v(" "+_vm._s(tag.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }